import { useParams } from "react-router-dom";
import Table from "../common/Table";
import DashboardLayout from "./DashboardLayout";
import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../../lib/axios";
import { Box, Stack, Typography } from "@mui/material";

export default function DynamicTable(){
    const {name} = useParams();

    const [data, setData] = useState({rows: [], title: "Stock Move Dashboard", loading: true, errors: {}})

    const handleFetchtable = useCallback(async () => {
        const response = await axiosInstance.get(`/analytics/table/${name}`);
        
        if (response.data && response.status === 200) {
            setData({
                loading: false,
                rows: response.data?.items,
                title: response.data?.title
            })
        }
    }, [name])

    useEffect(() => {
        handleFetchtable()
    }, [handleFetchtable])

    return (
        <DashboardLayout activePage="AnalyticsTables">
            <Stack spacing={0.5} sx={{ mb: 3, margin: '1rem' }}>
                <Typography
                variant="h4"
                sx={{
                    fontWeight: 800,
                    color: "#101828",
                    letterSpacing: "-0.02em",
                }}
                >
                {data.title}
                </Typography>

                <Typography
                sx={{
                    color: "#667085",
                    maxWidth: 700,
                }}
                >
                {data.subtitle || "Detailed SKU level insights to help you take action faster."}
                </Typography>
            </Stack>

            <Box
                sx={{
                backgroundColor: "#fff",
                border: "1px solid #e5e7eb",
                borderRadius: 2,
                p: 2,
                margin: "1rem"
                }}
            >
                <Table rows={data.rows} />
            </Box>

        </DashboardLayout>
    )
}